var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9156",
    "data-name": "Group 9156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3437",
    "data-name": "Rectangle 3437",
    width: 20,
    height: 20,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3089",
    "data-name": "Rectangle 3089",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_215",
    "data-name": "Mask Group 215",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 2.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M4,15.708A1.459,1.459,0,1,0,5.459,14.25,1.459,1.459,0,0,0,4,15.708Z",
    transform: "translate(13.083 -7.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M4,7.958A1.459,1.459,0,1,0,5.459,6.5,1.459,1.459,0,0,0,4,7.958Z",
    transform: "translate(13.083 -6.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M4,23.459A1.459,1.459,0,1,0,5.459,22,1.459,1.459,0,0,0,4,23.459Z",
    transform: "translate(13.083 -9.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M11.8,15H24.328a.833.833,0,1,1,0,1.667H11.8A.833.833,0,1,1,11.8,15Z",
    transform: "translate(-10.969 -7.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M11.8,22.75H24.328a.833.833,0,1,1,0,1.667H11.8a.833.833,0,1,1,0-1.667Z",
    transform: "translate(-10.969 -9.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M24.328,8.916H11.8a.833.833,0,0,1,0-1.667H24.328a.833.833,0,1,1,0,1.667Z",
    transform: "translate(-10.969 -6.625)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketCategory);
export default __webpack_public_path__ + "static/media/basket-category.08c2e15121f1c88282440ab2974f3b30.svg";
export { ForwardRef as ReactComponent };